<!-- <app-navbar-style-one></app-navbar-style-one> -->

<div class="inner-banner inner-bg10">
    <div class="container">
        <div class="inner-title text-center">
            <h3>المتاجر المفضلة</h3>
        </div>
    </div>
</div>
<div class="alert alert-success text-center" *ngIf="showSuccess" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;">
    {{successMsg}}
</div>

<div class="alert alert-danger text-center" *ngIf="showError" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;">
    {{errorMsg}}
</div>
<section class="checkout-area pt-100 pb-70" dir="rtl">
    <div class="container">
        <div class="favorite-container">
            <h3 class="section-title">المتاجر المفضلة</h3>
            
            <div *ngIf="favorites?.length === 0" class="empty-state">
                <i class="far fa-heart"></i>
                <p>لا يوجد متاجر مفضلة حالياً</p>
            </div>

            <div class="favorite-list">
                <div *ngFor="let vendor of favorites" class="vendor-card">
                    <div class="vendor-image">
                        <img [src]="vendor.avatar" 
                             (error)="handleImageError($event)"
                             alt="{{vendor.name}}">
                        <div class="vendor-status" [ngClass]="{
                            'status-open': vendor.status === 'open',
                            'status-closed': vendor.status !== 'open'
                        }">
                            {{vendor.status === 'open' ? 'مفتوح' : 'مغلق'}}
                        </div>
                    </div>
                    
                    <div class="vendor-info">
                        <div class="vendor-header">
                            <h4>{{vendor.name}}</h4>
                            <button class="heart-btn" (click)="toggleFavorite(vendor.id, vendor)">
                                <i [class]="vendor.isFavorite ? 'fas fa-heart' : 'far fa-heart'"></i>
                            </button>
                        </div>
                        
                        <div class="vendor-meta">
                            <span class="location">
                                <i class="fas fa-map-marker-alt"></i> {{vendor.city}}، {{vendor.country}}
                            </span>
                            <!-- <span class="rating">
                                <i class="fas fa-star"></i> {{vendor.rate || '0'}}
                            </span> -->
                        </div>
                        
                        <div class="vendor-delivery">
                            <span>
                                <i class="fas fa-clock"></i> {{vendor.deliveryTime}} دقيقة
                            </span>
                            <span>
                                <i class="fas fa-truck"></i> {{vendor.deliveryCost }} EGP
                            </span>
                        </div>
                        
                        <div *ngIf="vendor.subcategories?.length" class="vendor-categories">
                            <span *ngFor="let cat of vendor.subcategories.slice(0, 3)" class="category-tag">
                                {{cat.name}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <app-footer-style-two></app-footer-style-two> -->